// A search box for a page header. Narrows a list that is ALREADY on screen — it never
// fetches — so every screen using it holds its whole list in memory and filters in the
// browser. Shared the moment a second screen wanted one (clients, leads), which is also
// why the placeholder is passed in: what a screen searches is the screen's business.
export default function SearchBox({ value, onChange, placeholder }) {
  return (
    <input
      type="search"
      className="search-box"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  );
}
